import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { generalCatalogPost } from "../../store/generalCatalog/actions";
export var useGeneralCatalogPost = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseGeneralCatalogPost: (_a = state.GeneralCatalog.responseGeneralCatalogPost) === null || _a === void 0 ? void 0 : _a.data,
            errorGeneralCatalogPost: state.GeneralCatalog.errorGeneralCatalogPost,
            loadingGeneralCatalogPost: state.GeneralCatalog.loadingGeneralCatalogPost,
        });
    }), responseGeneralCatalogPost = _a.responseGeneralCatalogPost, errorGeneralCatalogPost = _a.errorGeneralCatalogPost, loadingGeneralCatalogPost = _a.loadingGeneralCatalogPost;
    useEffect(function () {
        if (trigger) {
            dispatch(generalCatalogPost({
                clientId: body.data.clientId,
                type: body.data.type,
                code: body.data.code,
                description: body.data.description,
            }));
        }
    }, [trigger, body.data.clientId]);
    return {
        responseGeneralCatalogPost: responseGeneralCatalogPost,
        errorGeneralCatalogPost: errorGeneralCatalogPost,
        loadingGeneralCatalogPost: loadingGeneralCatalogPost,
    };
};
